import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PasswordRecoverySetupComponent } from './components/password-recovery-setup/password-recovery-setup.component';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { CustomFormControlsModule } from '@app/shared/controls/form-controls/custom-form-controls.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SetNewPasswordComponent } from './pages/password-reset/set-new-password/set-new-password.component';
import { SimpleComponentsModule } from '@app/shared/ui/simple-components/simple-components.module';
import { PasswordExpirationComponent } from './components/password-expiration/password-expiration.component';
import { PipesModule } from '@app/shared/pipes/pipes.module';

@NgModule({
  declarations: [PasswordRecoverySetupComponent, PasswordExpirationComponent, SetNewPasswordComponent],
  imports: [
    CommonModule,
    ModalModule,
    ButtonModule,
    CustomFormControlsModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleComponentsModule,
    PipesModule,
  ],
  exports: [PasswordRecoverySetupComponent, SetNewPasswordComponent, PasswordExpirationComponent],
})
export class AuthSharedModule {}
